<template>
  <a-layout-content class="main-content">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </a-layout-content>
</template>

<style lang="less" scoped>
.main-content {
   margin: 16px;
}
</style>